import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import Employee from 'src/app/model/product/employee';
import { OtherTask } from 'src/app/model/task-list/other-task';
import { RequestService } from 'src/app/services/request.service';
import { SnackService } from 'src/app/services/snack.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import * as moment from 'moment';
import { Task } from 'src/app/model/task-list/task';

@Component({
  selector: 'create-edit-other-task',
  templateUrl: './create-edit-other-task.component.html',
  styleUrls: ['./create-edit-other-task.component.scss'],
})
export class CreateEditOtherTaskComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  task: OtherTask;
  @Input()
  employeeId: number;
  @Input()
  date: moment.Moment;
  @Input()
  employeeChoices: Employee[];

  init: boolean = false;
  saving: boolean = false;
  employeesLoaded: boolean = false;
  title: string;

  selectedEmployee: Employee;
  hourBudget: number;
  minuteBudget: number;

  public hours = GeneralHelper.hours;
  public minutes = GeneralHelper.minutes;

  constructor(
    public dialogRef: MatDialogRef<CreateEditOtherTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private requestService: RequestService,
    private snackService: SnackService
  ) {
    super();
    this.task = data.task;
    this.employeeId = data.employeeId;
    this.date = data.date;
    this.employeeChoices = data.employeeChoices;
  }

  ngOnInit(): void {
    if (this.task == null) {
      this.task = new OtherTask();
    }

    this.title = this.task.id == null ? 'Creëer taak' : 'Bewerk taak';
    this.selectedEmployee =
      this.employeeChoices != null
        ? this.employeeChoices.find((e) => e.id === this.employeeId)
        : null;
    this.hourBudget =
      this.task.minuteBudget != null
        ? Math.floor(this.task.minuteBudget / 60)
        : null;
    this.minuteBudget =
      this.task.minuteBudget != null ? this.task.minuteBudget % 60 : null;
    this.init = true;
  }

  taskDateChange(event) {
    this.date = event.value;
  }

  descriptionChanged(value: string) {
    this.task.description = value;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  compareNumbers(n1, n2) {
    return n1 == n2;
  }

  filterSundays(m: moment.Moment) {
    return m.day() !== 0;
  }

  saveTask() {
    if (this.date == null) {
      this.snackService.showError('Gelieve een datum te kiezen');
      return;
    }
    if (this.selectedEmployee == null) {
      this.snackService.showError('Gelieve een installateur te kiezen');
      return;
    }
    if (StringHelper.isEmpty(this.task.title)) {
      this.snackService.showError('Gelieve een titel in te vullen');
      return;
    }
    if (StringHelper.isEmpty(this.task.description)) {
      this.snackService.showError('Gelieve een omschrijving in te vullen');
      return;
    }
    if (this.hourBudget == null && this.minuteBudget == null) {
      this.snackService.showError('Gelieve een doorlooptijd te specificeren');
      return;
    }

    this.task.minuteBudget =
      (this.hourBudget == null ? 0 : Number(this.hourBudget) * 60) +
      (this.minuteBudget == null ? 0 : Number(this.minuteBudget));

    const requestBody: RequestBody = {
      task: this.task,
      date: this.date,
      employeeId: this.selectedEmployee.id,
    };
    this.saving = true;
    const observable =
      this.task.id == null
        ? this.requestService.post(requestBody, '/task/createTask')
        : this.requestService.putCustom(requestBody, '/task/updateTask');

    this.addSubscription(
      observable,
      (savedTask: Task) => {
        this.snackService.showSuccess('Taak succesvol opgeslagen');
        this.saving = false;
        this.dialogRef.close(savedTask);
      },
      (err) => {
        this.saving = false;
      }
    );
  }
}

interface RequestBody {
  task: OtherTask;
  date: moment.Moment;
  employeeId: number;
}
